export default {
  title: 'New Draft',
  continueButton: 'Continue to Setup',
  createDraftButton: 'Create Draft',
  cancelButton: 'Never mind',
}
